import { Col, Container, Row } from "react-bootstrap";
import { Desc, Heading } from "../../Global/Typography";
import GrassPattern from "../GrassPattern";
import "./Banner.scss";

const logo = "/images/EngraceVista/Banner/vista-logo.svg";
const BannerImage = "/images/EngraceVista/Banner/engrace_vista_3bhk_community.webp";

export default function Banner({ inView }) {
    return (
        <section
            className={`section overflow-hidden pb-0 ${inView ? "inView" : "outView"
                }`}
        >
            <GrassPattern />
            <Container className="pos-rel my-md-3">
                <Row>
                    <Col xs={11} md={10} lg={7} className="pr-5 py-5 mt-5">
                        <img
                            src={logo}
                            alt="logo"
                            className="SoulTreeLogo msSoulTreeBannerLogo msSoulTreeBannerLogo--sm"
                            style={{ height: "6rem" }}
                        />

                        <Heading
                            classList="my-4 pr-md-3"
                            variant="h1"
                            text="The True 3 BHK"
                        />
                        <Desc
                            classList="pr-md-3"
                            text="Engrace Vista is Sarjapur’s  exclusive 3 BHK community offering spacious flats ranging from 2116 to 2200 sq. ft. 

              "
                        />
                    </Col>
                </Row>

                <img
                    src={logo}
                    alt="Engrace Vista"
                    className="SoulTreeLogo msSoulTreeBannerLogo msSoulTreeBannerLogo--md"
                    style={{ height: "8rem" }}
                />

                {/* NEW IMAGE */}
                {/* <Row>
          <Col md={12} className="p-0">
            <div className="md-container-wrap">
              <img src={BannerImage} alt="logo" className="-banner-image" />
            </div>
          </Col>
        </Row> */}
            </Container>
            <div className="md-container-wrap">
                <img src={BannerImage} alt="Engrace Vista Exclusive 3 BHK Community -Luxurious living spaces in exclusive and
a prestigious residential enclave." className="-banner-image" />
            </div>
            <GrassPattern />
        </section>
    );
}
